<template>
  <vue-perfect-scrollbar
    class="inbox-content-scroll"
    :style="$store.getters.generalScrollStyle"
  >
    <div>
      <v-container grid-list-md>
        <v-usuario
          v-if="mostrar"
          v-bind="props"
          v-on:alGuardar="alGuardar"
        ></v-usuario>
      </v-container>
    </div>
  </vue-perfect-scrollbar>
</template>

<script>
import VUsuario from '@/modules/administracion/usuarios/components/Usuario/VUsuario'

export default {
  name: 'UsuariosDetalleUsuario',
  components: { VUsuario },
  props: {
    id: {
      type: Number,
      required: true
    },
    operacion: {
      type: String,
      default: 'modif',
      validator: function (value) {
        return ['modif', 'lectura'].indexOf(value) !== -1
      }
    },
    permiso: {
      type: String,
      required: true
    },
    origen: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      mostrar: true,
      cargando: false,
      props: {
        operacion: this.operacion,
        permiso: this.permiso,
        origen: this.origen
      }
    }
  },
  methods: {
    alGuardar (datos) {
      if (this.$store.getters.getUser.id === datos.id) {
        this.$store.dispatch('usuario')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
